<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-09-22 10:33:26
 * @LastEditors: Chenhw2017 1272617071@qq.com
 * @LastEditTime: 2024-06-13 18:17:52
 * @FilePath: /chaoyongtuan/src/views/shopManage/orderDetails/list/components/tableCell/activityCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="activity-cell">
		<div class="font-h6-medium fz-12">{{ row.belong_text | formatEmpty }}</div>
		<div class="font-h6-medium fz-12 yx-color-text-regular">归属时间：{{ row.belong_time | formatEmpty }}</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
	components: {},
	data() {
		return {};
	},
	methods: {},
};
</script>
<style lang="less" scoped>
.activity-head {
	display: flex;
	align-items: center;
	.activity-name {
		color: @color-text-primary;
	}
}
.activity-bottom {
	color: #4e596a;
}
</style>
